'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'sun-bright';
var width = 576;
var height = 512;
var aliases = ["sun-alt"];
var unicode = 'e28f';
var svgPathData = ['M0 232l0 48 112 0 0-48-112 0zM67.4 69.3l79.2 79.2 33.9-33.9-79.2-79.2-33.9 33.9zm0 373.4l33.9 33.9 79.2-79.2-33.9-33.9-79.2 79.2zM264-32l0 112 48 0 0-112-48 0zm0 464l0 112 48 0 0-112-48 0zM395.5 114.6l33.9 33.9 79.2-79.2-33.9-33.9-79.2 79.2zm0 282.8l79.2 79.2 33.9-33.9-79.2-79.2-33.9 33.9zM464 232l0 48 112 0 0-48-112 0z', 'M160 256a128 128 0 1 1 256 0 128 128 0 1 1 -256 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSunBright = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;